import AppContainer from "../Structure/AppContainer";
import React, { useContext, useEffect, useState } from "react";
import Select from "react-select";
import toast, { Toaster } from "react-hot-toast";
import AuthContext from "../../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import useStateCallback from "../../util/customHooks/useStateCallback";
import { useFilter } from "../../Context/FilterContext";
import UpdateStationModal from "./UpdateStationModal";
import ajaxStations from "../../util/remote/ajaxStations";
import RegisterstationsGroupsModal from "./RegisterstationsGroupsModal";
import ajaxStationsGroups from "../../util/remote/ajaxStationsGroups";
const ViewFuelStationGroups = () => {
  const { toggleFilter, filterVisible } = useFilter();
  const itemsPerPageOptions = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];
  const { userId } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [ownersList, setOwnersList] = useState([]);
  const [meta, setMeta] = useState([]);
  const [page, setPage] = useState(1);
  const [viewType, setViewType] = useState("table view");
  const [search, setSearch] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  // Fetch Station Owners
  const fetchGroups = async () => {
    setLoading(true);

    const response = await ajaxStationsGroups.list_stations_groups();
    if (response.status === "OK") {
      setOwnersList(response.details || []);
    } else {
      toast.error(response.message || "Failed to fetch owners");
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchGroups();
  }, [page, search, itemsPerPage]);
  const toggleView = (type) => setViewType(type);
  const [update, setUpdate] = useStateCallback(false);
  const handleViewDetails = (owner) => {
    setUpdate(false, () =>
      setUpdate(<UpdateStationModal data={owner} func={fetchGroups} />)
    );
  };
  const [Registers, setRegisters] = useStateCallback(false);
  const handleRegister = () => {
    setRegisters(false, () =>
      setRegisters(<RegisterstationsGroupsModal func={fetchGroups} />)
    );
  };
  const filteredActions = [
    {
      label: "card view",
      icon: "fa-regular fa-address-card",
      className: "btn btn-success btn-sm",
      onClick: () => toggleView("card view"),
    },
    {
      label: "table view",
      icon: "fa-solid fa-table",
      className: "btn btn-success btn-sm",
      onClick: () => toggleView("table view"),
    },
    {
      label: "Register Group",
      icon: "fa-solid fa-file-pen",
      className: "btn btn-primary btn-sm",
      onClick: () => handleRegister(),
    },
  ].filter((action) => action.label !== viewType);
  <i class="fa-regular fa-address-card"></i>;
  return (
    <AppContainer
      title="Station Groups"
      previousPageTitle="Dashboard"
      actions={filteredActions}
    >
      <div className="container-fluid">
        <Toaster />
        {update}
        {Registers}

        {/* Loading / No Data */}
        {loading ? (
          <div className="text-center my-5 fs-5 text-muted">
            Loading owners...
          </div>
        ) : ownersList.length === 0 ? (
          <div className="text-center my-5 fs-5 text-muted">
            No owners found
          </div>
        ) : viewType === "table view" ? (
          <>
            <div className="row">
              <div className="col-sm-12 col-xl-12 col-lg-12">
                <div className="card custom-card">
                  <div className="card-body">
                    <div>
                      <h6 className="card-title mb-1">Fuel Stations</h6>
                      <p className="text-muted card-sub-title">
                        List of registered stations
                      </p>
                    </div>
                    <div className="table-responsive">
                      <table className="table table-bordered text-nowrap mb-0">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Group Name</th>
                            <th>Created At</th>
                            <th>Updated At</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {ownersList.map((group, index) => (
                            <tr key={group.id}>
                              <td>{(page - 1) * itemsPerPage + index + 1}</td>
                              <td>{group.group_name}</td>
                              <td>{group.created_at}</td>
                              <td>{group.updated_at}</td>
                              <td>
                                <button
                                  className="btn btn-sm btn-info"
                                  onClick={() => handleViewDetails(group)}
                                >
                                  <i className="fe fe-edit-2"></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="row">
              {ownersList.map((group) => (
                <div className="col-md-4 col-lg-3 mb-3" key={group.id}>
                  <div
                    className="card h-100 text-center"
                    style={{
                      borderRadius: "14px",
                      overflow: "hidden",
                      boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                      paddingTop: "40px",
                      position: "relative",
                    }}
                  >
                    {/* Profile Image */}
                    <div style={{ marginTop: "-30px" }}>
                      <img
                        src={process.env.PUBLIC_URL + "/gas station.jpeg"}
                        alt="group icon"
                        style={{
                          width: "70px",
                          height: "70px",
                          borderRadius: "50%",
                          marginTopTop: "10px",
                          objectFit: "cover",
                          border: "3px solid white",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                        }}
                      />
                    </div>

                    {/* Card Body */}
                    <div className="card-body">
                      <h6 className="mb-1">{group.group_name}</h6>

                      <small className="d-block text-dark">
                        Created: {group.created_at}
                      </small>

                      <small className="d-block text-dark">
                        Updated: {group.updated_at}
                      </small>

                      <button
                        className="btn btn-sm btn-outline-primary px-3 mt-3"
                        onClick={() => handleViewDetails(group)}
                      >
                        <i className="fe fe-edit-2"></i> Edit
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </AppContainer>
  );
};
export default ViewFuelStationGroups;
